import { render, staticRenderFns } from "./ViewAngleToggleSwitcherParts.vue?vue&type=template&id=cb0f5aba&scoped=true"
import script from "./ViewAngleToggleSwitcherParts.vue?vue&type=script&lang=ts"
export * from "./ViewAngleToggleSwitcherParts.vue?vue&type=script&lang=ts"
import style0 from "./ViewAngleToggleSwitcherParts.vue?vue&type=style&index=0&id=cb0f5aba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb0f5aba",
  null
  
)

export default component.exports